import { Appearance, ProductType } from '@/types';
import { isSizeAvailable } from './isSizeAvailable';

export const getSizesByAvailability = (
  productType: ProductType,
  appearance: Appearance,
  available: boolean
) =>
  productType.sizes.filter(
    (size) => available === isSizeAvailable(productType, appearance, size.id)
  );
